import { BooleanFilter } from "./boolean-filter";
import { IntegerFilter } from "./integer-filter";
import { ItemFilter } from "./item-filter";
import { StringFilter } from "./string-filter";

export class UserFilter {
    public id?: IntegerFilter;
    public firstName?: StringFilter;
    public lastName?: StringFilter;
    public email?: StringFilter;
    public roles?: ItemFilter;
    public isActive?: BooleanFilter;
}
